export interface IStatus {
  Code: number
  Message: string
}
